import React from 'react'

export const Paralax2 = () => {
  return (
    <div>
        <div className="parallax2">
            <div className="parallax2-content">
                <h1>Small Parallax Section</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus imperdiet rhoncus porta. Ut quis sem quis purus lobortis dictum. Aliquam nec dignissim nisl. Vivamus cursus feugiat sapien, eget tincidunt leo ornare quis.</p>
                <button className='btn1'>Read More</button>

            </div>
        </div>
    </div>
  )
}
